// dependencies
import { fromJS } from "immutable";
import moment from "moment";
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";
import serializeObject from "../../utils/SerializeObject";

export const ReviewsGet = CreateProcess({
	method: "GET",
	name: "ReviewsGet",
	type: "REVIEWS:GETSINGLE",

	request: (props) => ({
		url: `/api/v0.1/reviews/${props.reviewID}/`,
	}),

	success: (response) => fromJS(response.data),
});

export const ReviewReportGetSingle = CreateProcess({
	method: "GET",
	name: "ReviewReportGetSingle",
	type: "REVIEWS:REPORT.GETSINGLE",

	request: (props) => ({
		url: `/api/review-reports/${props.reportID}/`,
	}),

	success: (response) => fromJS(response.data.reviewReport),
});

export const ReviewReportGetBulk = CreateProcess({
	method: "GET",
	name: "ReviewReportGetBulk",
	type: "REVIEWS:REPORT.GETBULK",

	request: (props) => {
		const queryParams = serializeObject(props.params);

		return {
			url: `/api/review-reports/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;

		const reviewReports = data.reviewReports.map((report) => {
			report.id = report._id;
			report.startDate = report.start_date ? moment(report.start_date) : null;
			report.completeDate = report.complete_date ? moment(report.complete_date) : null;
			report.authorsDueDate = report.authors_due_date ? moment(report.authors_due_date) : null;
			report.signersDueDate = report.signers_due_date ? moment(report.signers_due_date) : null;

			return report;
		});

		return {
			totalCount,
			reviewReports,
		};
	},
});

export const ReviewsGetBulk = CreateProcess({
	method: "GET",
	name: "ReviewsGetBulk",
	type: "REVIEWS.GETBULK",

	request: (props) => {
		const queryParams = serializeObject(props.params);
		return {
			url: `/api/reviews/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;

		const reviews = data.reviews.map((review) => {
			review.id = review._id;
			review.startDate = review.start_date ? moment(review.start_date) : null;
			review.completeDate = review.complete_date ? moment(review.complete_date) : null;
			review.authorsDueDate = review.authors_due_date ? moment(review.authors_due_date) : null;
			review.signersDueDate = review.signers_due_date ? moment(review.signers_due_date) : null;

			return review;
		});

		return {
			totalCount,
			reviews,
		};
	},
});

export const TeamReviewsGetBulk = CreateProcess({
	method: "GET",
	name: "TeamReviewsGetBulk",
	type: "REVIEWS.TEAM.GETBULK",

	request: (props) => {
		const queryParams = serializeObject(props.params);
		return {
			url: `/api/reviews/team/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;

		const teamReviews = data.teamReviews.map((review) => {
			review.id = review._id;
			review.startDate = review.start_date ? moment(review.start_date) : null;
			review.completeDate = review.complete_date ? moment(review.complete_date) : null;
			review.authorsDueDate = review.authors_due_date ? moment(review.authors_due_date) : null;
			review.signersDueDate = review.signers_due_date ? moment(review.signers_due_date) : null;

			return review;
		});

		return {
			totalCount,
			teamReviews,
		};
	},
});

// reviews that a user can add an easy add form to
export const ReviewsGetEasyAdd = CreateProcess({
	method: "GET",
	name: "ReviewsGetEasyAdd",
	type: "REVIEWS.GET_EASY_ADD",

	request: (props) => {
		const queryParams = serializeObject(props.params);
		const userID = get(props, ["params", "userID"], props.userID);
		const subjectID = get(props, ["params", "subjectID"], props.subjectID);
		return {
			url: `/api/reviews/easy-add/${userID}/${subjectID}/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;

		return {
			data,
		};
	},
});

export const AddFormToReview = CreateProcess({
	method: "POST",
	name: "addFormToReview",
	type: "REVIEW:ADDFORM",

	request: (props) => ({
		url: `/api/v0.1/reviews/${props.reviewID}/easy_add/${props.easyAddID}/`,
		payload: props.payload,
	}),
	success: (response) => response.data,
});

export const getAllReviews = CreateProcess({
	method: "GET",
	name: "getAllReviews",
	type: "REVIEWS:GETALL",

	request: (props) => {
		const queryParams = serializeObject(props.params);

		return {
			url: `/api/company/reviews/all/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;
		const { reviews } = data;

		return {
			reviews,
			totalCount,
		};
	},
});

export const DownloadReviewCsvJob = CreateProcess({
	method: "GET",
	name: "DownloadReviewCsvJob",
	type: "REVIEWS:DOWNLOADCSV",

	request: (props) => ({
		url: `/review-cycle/${props.cycleId}/csv?tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
	}),
	success: (response) => fromJS(response.data),
});
